// src/components/TimeTrackingRoutes.js
// Time Tracking route configuration - handles navigation for Time & Attendance section
// Integrates with React Router for proper routing structure

import React from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { TimeTracking } from "./TimeTracking";
import { EmployeeTimeRecords } from "./EmployeeTimeRecords";

/**
 * The employee DTR page, keyed on employeeId so moving to another employee is a
 * fresh mount with no previous employee's records loaded (PRD_InAppNotifications
 * C10) — record ids repeat across employees, so a stale page could otherwise
 * open, and save over, the wrong employee's record from a ?editRecord link.
 */
export const EmployeeTimeRecordsRoute = () => {
  const { employeeId } = useParams();
  return <EmployeeTimeRecords key={employeeId} />;
};

/**
 * TimeTrackingRoutes component
 * Manages all routes under the /time-tracking path
 * Provides navigation between list view, individual editor, and kiosk setup
 */
export const TimeTrackingRoutes = () => {
  return (
    <Routes>
      {/* Time Tracking - Main landing page with new UI */}
      <Route index element={<TimeTracking />} />

      {/* Individual Employee Time Records Page (Monthly View) */}
      <Route path="employee/:employeeId" element={<EmployeeTimeRecordsRoute />} />

      {/* Catch-all redirect to main time tracking page */}
      <Route path="*" element={<Navigate to="/time-tracking" replace />} />
    </Routes>
  );
};
